import React, { useState } from 'react';
import styles from './FBMScheduleDropOff.module.scss';
import { Col, Container, Row, TabContent, TabPane } from 'reactstrap';
import BrandsFilterTabs from '../../../components/SellerPortalComponents/BrandsFilterTabs/BrandsFilterTabs';
import DropOffSchedule from '../../../components/FBMPortalComponents/ScheduleDropOffComponents/DropOffSchedule/DropOffSchedule';
import DropOffHistory from '../../../components/FBMPortalComponents/ScheduleDropOffComponents/DropOffHistory/DropOffHistory';
import DropOffGuidelines from '../../../components/FBMPortalComponents/ScheduleDropOffComponents/DropOffGuidelines/DropOffGuidelines';

const dropoffTabs = [
    { id: '1', label: 'Drop Off Schedule' },
    { id: '2', label: 'Drop Off History' },
    { id: '3', label: 'Guidelines and Instructions' },
];

const FBMScheduleDropOff = () => {
    const [activeTab, setActiveTab] = useState('1');

    return (
        <div className={styles.mainScheduleDropOffContainer}>
            <Container fluid className={styles.scheduleDropOffWrapper}>
                <Row className={styles.scheduleDropOffRow}>
                    <Col xs="12">
                        <BrandsFilterTabs
                            tabs={dropoffTabs}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                    </Col>
                </Row>

                <Row className='g-0'>
                    <Col>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId='1'>
                                {activeTab === '1' && <DropOffSchedule />}
                            </TabPane>
                            <TabPane tabId='2'>
                                {activeTab === '2' && <DropOffHistory />}
                            </TabPane>
                            <TabPane tabId='3'>
                                {activeTab === '3' && <DropOffGuidelines />}
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default FBMScheduleDropOff;